<template>
    <div>
        <v-card elevation="0">
            <v-card-text style="color: black;" v-if="!submissionsuccessful">
                <v-form ref="form" aria-autocomplete="off">
                <v-row>
                    <v-col cols="12" md="1">
                        <v-img src="../../../assets/background/Kings_international_3308.jpg" width="100%" height="120px" contain></v-img>
                    </v-col>
                    <v-col cols="12" md="10" class="d-flex align-center">
                        <span>
                            <span class="text-h4">Application Form for Part-Time Faculty Appointments - CUPE 5265</span><br />
                            <b>
                                King's University College is committed to recognizing the dignity and independence of all and seeks to ensure that persons with disabilities have genuine, open and unhindered access to the College's employment opportunities.
                                If you require an accommodation during the recruitment process, please contact Human Resources at <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or 519-433-3491 for assistance.
                            </b>
                        </span>
                    </v-col>
                </v-row>
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-text>
                        <b>Have you held a CUPE position at King's in the past 36 months?</b><br />
                        <v-select :items="items" outlined v-model="taughtatkings" @change="showSteppers" hide-details dense></v-select>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-text>
                        <b>Are you legally eligible to work in Canada?</b><br />
                        <v-select :items="items" outlined v-model="eligibletowork" @change="showSteppers" hide-details dense></v-select>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-title>Course Application&#40;s&#41;</v-card-title>
                    <v-card-text v-for="item in posting" :key="item.id">
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th colspan="11">{{ item.title }} - {{ item.type }} Posting</th>
                                    </tr>
                                    <tr>
                                        <th rowspan="2">Term</th>
                                        <th rowspan="2">Section</th>
                                        <th rowspan="2">Class#</th>
                                        <th rowspan="2">Course</th>
                                        <th rowspan="2">Subject</th>
                                        <th rowspan="2">Name</th>
                                        <th rowspan="2">Component</th>
                                        <th colspan="5" style="text-align: center;">Days</th>
                                        <th rowspan="2">Instruction Period</th>
                                        <th rowspan="2">Time</th>
                                    </tr>
                                    <tr>
                                        <th>Mon</th>
                                        <th>Tue</th>
                                        <th>Wed</th>
                                        <th>Thu</th>
                                        <th>Fri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in item.courses" :key="course.classnbr">
                                        <td>{{ resolveTerm(course.sessioncode) }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td>{{ course.classnbr }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course['subject-resolved'] }}</td>
                                        <td>{{ course.descr }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                        <td><v-checkbox v-model="course.mon" disabled true-value="Mon" dense></v-checkbox></td>
                                        <td><v-checkbox v-model="course.tues" disabled true-value="Tue" dense></v-checkbox></td>
                                        <td><v-checkbox v-model="course.wed" disabled true-value="Wed" dense></v-checkbox></td>
                                        <td><v-checkbox v-model="course.thurs" disabled true-value="Thu" dense></v-checkbox></td>
                                        <td><v-checkbox v-model="course.fri" disabled true-value="Fri" dense></v-checkbox></td>
                                        <td>{{ course.instructionstart }} ~ {{ course.instructionend }}</td>
                                        <td>{{ course.starttime }} ~ {{ course.endtime }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>
                    </v-card-text>
                </v-card>
                <v-stepper v-model="e1" non-linear alt-labels v-if="stepper">
                    <v-stepper-header>
                        <v-stepper-step step="1" color="#004236" :rules="[()=> step1]" >
                           General Information
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" color="#004236" :rules="[() => step2]">
                            Education
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3" color="#004236" :rules="[() => step3]">
                            Employment History
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4" color="#004236" :rules="[() => step4]">
                            References
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="5" color="#004236" :rules="[() => step5]">
                            Documents
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-overlay absolute :value="callingprofile">
                            <v-row justify="center" align="center" align-content="center" class="fill-height">
                                <v-col>
                                    <v-progress-circular indeterminate color="#6d6e71"  :size="24"></v-progress-circular>&nbsp;Profile loading...
                                </v-col>
                            </v-row>
                        </v-overlay>
                        <v-stepper-content step="1">
                            <v-card color="#f7f7f6">
                                <v-card-title>
                                    General Information
                                </v-card-title>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="4">
                                            <v-text-field label="First Name" outlined v-model="generalinfo.firstname" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="Last Name" outlined v-model="generalinfo.lastname" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="Preferred Name" outlined v-model="generalinfo.preferredname"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field label="Street Address" outlined v-model="generalinfo.address.street" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="City" outlined v-model="generalinfo.address.city" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="Province" outlined v-model="generalinfo.address.province" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="Postal Code" outlined v-model="generalinfo.address.postalcode" :rules="[rules.required]"></v-text-field>    
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Home Phone" outlined v-model="generalinfo.phone.home"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Cell Phone" outlined v-model="generalinfo.phone.cell"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field disabled label="Email Address" outlined v-model="generalinfo.email"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Western Email Address (optional)" outlined v-model="generalinfo.westernemail" :rules="[rules.email]"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <span style="font-size: small; color: grey;">*Application confirmation email will be sent to the selected preferred email.</span><br/>
                                            <v-radio-group v-model="generalinfo.preferredemail" mandatory row label="Preferred Email Adress" @change="checkwesternEmail()">
                                                <v-radio
                                                    label="Email Address"
                                                    value="email"
                                                ></v-radio>
                                                <v-radio
                                                    label="Western Email Address"
                                                    value="western"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#004236" @click="validateStep1(2)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card color="#f7f7f6">
                                <v-card-title>Educational History</v-card-title>
                                <v-card-subtitle>
                                    <v-icon color="#FF8300" small>mdi-alert-circle</v-icon>&nbsp;Please list highest degree first
                                </v-card-subtitle>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12" v-for="(count, i) in educationcount" :key="i">
                                            <v-row dense>
                                                <v-col cols="12">Entry #{{count}}</v-col>
                                                <v-col cols="12"><v-text-field label="Degree" outlined v-model="education[count-1].degree" :rules="[rules.required]"></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="University Attended" outlined v-model="education[count-1].university" :rules="[rules.required]"></v-text-field></v-col>
                                                <v-col cols="12"><v-select label="Status" :items="educationitems" outlined v-model="education[count-1].status" :rules="[rules.requiredSelect]"></v-select></v-col>
                                                <v-col cols="12"><v-text-field label="Area of Specialization" outlined v-model="education[count-1].specialization" :rules="[rules.required]"></v-text-field></v-col>      
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-col cols="12"><v-btn text color="#167D7F" @click="addEducationalHistory" v-if="addmoreeducation">Add another Educational History Entry</v-btn></v-col>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#004236" @click="validateStep2(1)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <v-btn color="#004236" @click="validateStep2(3)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card color="#f7f7f6">
                                <v-card-title>Employment History</v-card-title>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="6">
                                            <span class="text-body-2">Have you worked for King's University College before?</span><br />
                                            <v-select :items="items" outlined v-model="employment.taught"></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <span class="text-body-2">
                                                You can find your Employee ID on the <a :href="seniorityURL" target="_blank">CUPE Seniority List</a>.
                                            </span><br/>
                                            <v-text-field label="Employee Number (if known)" outlined v-model="employment.employeenumber" :disabled="employment.taught == 'No' || employment.taught == 'Please select...'"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea height="100px" label="Course(s) taught at King's (if applicable)" outlined dense v-model="employment.courses" :disabled="employment.taught == 'No' || employment.taught == 'Please select...'"></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#004236" @click="validateStep3(2)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <v-btn color="#004236" @click="validateStep3(4)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card color="#f7f7f6">
                                <v-card-title>References</v-card-title>
                                <v-card-text>
                                    <v-row v-for="(count, i) in 3" :key="i" dense>
                                        <v-col cols="12">Reference {{count}}</v-col>
                                        <v-col cols="12"><v-text-field label="Name" outlined v-model="references[count-1].name" :rules="[rules.required]"></v-text-field></v-col>
                                        <v-col cols="12"><v-text-field label="Academic Affiliation" outlined v-model="references[count-1].academicaffiliation" :rules="[rules.required]"></v-text-field></v-col>
                                        <v-col cols="12"><v-text-field label="Email Address" outlined v-model="references[count-1].email" :rules="[rules.referenceemail]"></v-text-field></v-col>
                                        <v-col cols="12"><v-text-field label="Phone" outlined v-model="references[count-1].phone" :rules="[rules.required]"></v-text-field></v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#004236" @click="validateStep4(3)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <v-btn color="#004236" @click="validateStep4(5)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="5">
                            <v-card color="#f7f7f6">
                                <v-card-title>Supporting Documents</v-card-title>
                                <v-card-subtitle style="color: #FF8300;"><v-icon color="#FF8300">mdi-alert-outline</v-icon>&nbsp;File attachments should not exceed 10MB in total.</v-card-subtitle>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12"><b>Attach Curriculum Vitae</b></v-col>
                                        <v-col cols="12"><v-file-input show-size label="Resume/CV" outlined v-model="applicantCV" :rules="[rules.required]" id="fileCV"></v-file-input></v-col>
                                    </v-row><br />
                                    <v-row dense>
                                        <v-col cols="12"><b>Supplemental Documentation</b> &#40;optional&#41;</v-col>
                                        <v-col cols="12">Please attach supplemental documentation as relevant.</v-col>
                                        <v-col cols="8"><v-file-input show-size label="Supplemental Attachment 1" outlined v-model="supplementdoc1" id="suppledoc1"></v-file-input></v-col>
                                        <v-col cols="4"><v-select label="Type" outlined v-model="supplementdoctype1" :items="doctypes" :disabled="supplementdoc1 == null || supplementdoc1 == ''"></v-select></v-col>
                                        <v-col cols="8"><v-file-input show-size label="Supplemental Attachment 2" outlined v-model="supplementdoc2" id="suppledoc2"></v-file-input></v-col>
                                        <v-col cols="4"><v-select label="Type" outlined v-model="supplementdoctype2" :items="doctypes" :disabled="supplementdoc2 == null || supplementdoc2 == ''"></v-select></v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-checkbox v-model="finalcheck">
                                        <template v-slot:label>
                                            <div>
                                                <span class="text-h6">Application Confirmation</span><br />
                                                I understand that applications will only be considered for the actual CUPE course&#40;s&#41; that I apply to.<br />
                                                I attest that all of the information I have entered and included as part of my application is true, accurate, and complete to the best of my knowledge.
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#004236" @click="validateStep5(4)" fab small elevation="0">
                                        <v-icon color="white">mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <v-btn color="#004236" dark @click="validateForm()">
                                        Submit Application
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-form>
            </v-card-text>
            <v-card-text v-else>
                <v-container style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            <v-alert :type="submissiontype" outlined prominent border="left">
                                {{ submissionText }}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogConfirm" width="700px" persistent>
            <v-card elevation="0">
                <v-card-title class="text-h5 grey lighten-2">Application Submission</v-card-title>
                <v-card-text>
                    <br />
                    <b>I understand that applications will only be considered for the actual CUPE course&#40;s&#41; that I apply to.<br /><br />
                    I attest that all of the information I have entered and included as part of my application is true, accurate, and complete to the best of my knowledge.</b>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#05445E" @click="dialogConfirm = false">Dismiss</v-btn>
                    <v-btn text color="#05445E" @click="submitApplication" :loading="submissionloading">Submit</v-btn>
                </v-card-actions>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogValidation" width="650px">
            <v-card elevation="0">
                <v-toolbar
                    dark
                    color="#E57F84"
                    elevation="0"
                >
                    <v-toolbar-title>You have incompleted fields</v-toolbar-title>
                </v-toolbar>
                <v-card-text><br />
                    <span>The following fields are not completed or does not meet requirements: </span><br />
                    <v-list-item dense two-line v-for="fields in validatedFields" :key="fields.field">
                        <v-list-item-content>
                            <v-list-item-title>{{ fields.field }}</v-list-item-title>
                            <v-list-item-subtitle>{{ fields.explanation }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#05445E" @click="dialogValidation = false">Go Back</v-btn>
                </v-card-actions>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSubmissionsuccessful" width="650px">
            <v-card elevation="0">
                <v-toolbar dark color="#59981A" elevation="0" >
                    <v-toolbar-title>Application Submitted</v-toolbar-title>
                </v-toolbar>
                <v-card-text><br />
                    Your application has been submitted successfully. <br />
                    Confirmation email receipt is sent to <b><span v-if="generalinfo.preferredemail == 'email'">{{ generalinfo.email }}</span><span v-else>{{ generalinfo.westernemail }}</span></b>. <br /><br />
                    Please check your spam/junk folders and ensure that you have received the email.<br />
                    If you haven't received the email within 24 hours, please contact to King's Human Resources at <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or 519-433-3491.<br /><br />
                    Thank you for your interest in the position. 
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#05445E" @click="dialogSubmissionsuccessful = false">OK</v-btn>
                </v-card-actions>
                <br />
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from "../../../js/auth"
export default {
    props: {
        posting: {
            required: true
        }
    },
    data () {
      return {
        host: location.hostname.toString(),
        e1: 1,
        items: ['Please select...', "Yes", "No"],
        taughtatkings: "Please select...",
        eligibletowork: "Please select...",
        callingprofile: false,
        generalinfo: {
            "firstname": "",
            "lastname": "",
            "email": "",
            "phone" : {
                "cell": "",
                "home": ""
            },
            "address": {
                "street": "",
                "city": "",
                "province": "",
                "postalcode": ""
            },
            "preferredemail": "email",
            "westernemail": ""
        },
        rules: {
            required: value => !!value || 'Required Field.',
            requiredSelect: value => !/^Please select.../.test(value) || "Required Field",
            email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) && /uwo.ca$/.test(v)|| "Invalid Western email format",
            referenceemail: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Invalid email format"
        },
        educationitems: ['Please select...', 'Completed', 'ABD - Active In Program', 'Discontinued'],
        educationcount: 1,
        addmoreeducation: true,
        education: [{
            "degree": "",
            "university": "",
            "status": "Please select...",
            "specialization": ""
        }],
        employment: {
            "taught" : "",
            "employeenumber": "",
            "courses": ""
        },
        references: [
            {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
            {"name" : "", "academicaffiliation": "", "email": "", "phone": "",},
            {"name" : "", "academicaffiliation": "", "email": "", "phone": "",}
        ],
        applicantCV: null,
        supplementdoc1: null,
        supplementdoc2: null,
        supplementdoctype1: "Please select...",
        supplementdoctype2: "Please select...",
        doctypes: [],
        stepper: false,
        finalcheck: false,
        step1: true,
        step2: true,
        step3: true,
        step4: true,
        step5: true,
        dialogValidation: false,
        validatedFields: [],
        dialogConfirm: false,
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
        submissionloading: false,
        dialogSubmissionsuccessful: false,
        submissionsuccessful: false,
        submissionText: "",
        submissiontype: "",
        seniorityURL: ""
      }
    },
    methods: {
        resolveGeneralTerm(){
            const that = this;
            let term = that.posting[0].strm.slice(-1);
            if(term == "9"){
                var year = that.posting[0].strm[1]+that.posting[0].strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(that.posting[0].strm[0])-1).toString();
                return "FALL2"+century+year+"/WINTER2"+century+year2;
            }else if(term == "5"){
                return "SUMMER";
            }
        },
        resolveTerm(session){
            const that = this;
            let term = that.posting[0].strm.slice(-1);
            var year = that.posting[0].strm[1]+that.posting[0].strm[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(that.posting[0].strm[0])-1).toString();
            if(term == "9"){
                if(session == "0" || session == "5" || session == "Q5"){
                    return "FALL2"+century+year+"/WINTER2"+century+year2;
                }else if(session == "1" || session == "6"){
                    return "FALL 2"+century+year
                }else{
                    return "WINTER 2"+century+year2
                }
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        showSteppers(){
            const that = this;
            if(that.taughtatkings != "Please select..." && that.eligibletowork != "Please select..." ){
                that.callProfile();
                that.initialize();
                that.stepper = true;
                if(that.taughtatkings == "Yes"){
                    that.employment.taught = "Yes"
                }else {
                    that.employment.taught = "No"
                }
            }else {
                that.stepper = false;
            }
        },
        callProfile(){
            const that = this;
            that.callingprofile = false;
            let user = auth.get_user();
            
            if(user.department != "applicant"){
                that.generalinfo = {
                    "firstname": "Test Applicant",
                    "lastname": "Sample",
                    "email": "someone@somewhere.com",
                    "phone" : {
                        "cell": "5190000000",
                        "home": ""
                    },
                    "address": {
                        "street": "266 Epworth Ave",
                        "city": "London",
                        "province": "Ontario",
                        "postalcode": "N6A2M3"
                    },
                    "preferredemail": "email",
                    "westernemail": ""
                };
            }else {
                that.callingprofile = true;
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getprofile&data={"uid":"'+user["uid"]+'"}';

                //API calling
                fetch(api)
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            let result = resultData["data"][0];
                            that.generalinfo = result;

                            if(result["education"] && result["education"].length > 0){
                                that.education = result["education"];
                                that.educationcount = result["education"].length;
                            }else {
                                that.education = [{
                                    "degree": "",
                                    "university": "",
                                    "status": "Please select...",
                                    "specialization": ""
                                }];
                                that.educationcount = 1;
                            }

                            if(result["employment"] && (result["employment"]["employeenumber"] != "" || result["employment"]["courses"] != "")){
                                that.employment = result["employment"];
                                that.employment["taught"] = "Yes";
                            }else {
                                that.employment = {
                                    "taught" : "No",
                                    "employeenumber": "",
                                    "courses": ""
                                }
                            }

                            if(result["references"]){
                                that.references = result["references"];
                            }
                        }
                        that.callingprofile = false;
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.callingprofile = false;
                    })
                //End of API calling
            }
        },
        initialize(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                if(element["type"] == "attachtypes"){
                                    that.doctypes = ["Please select...", ...element["config"]["doctypes"]];
                                }

                                if(element["type"] == "seniorityURL"){
                                    that.seniorityURL = element["config"]["url"];
                                }
                            });
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        checkwesternEmail(){
            const that = this;
            if(/uwo.ca$/.test(that.generalinfo.westernemail)){
                that.generalinfo.preferredemail = "western";
            }else {
                that.setSnackbar("Please enter valid western email", "#EF6C00");
                that.generalinfo.preferredemail = "email";
            }
        },
        addEducationalHistory(){
            const that = this;
            if(that.educationcount < 6){
                that.educationcount = that.educationcount+1;
                if(that.educationcount == 5){
                    that.addmoreeducation = false;
                }
                that.education.push({
                    "degree": "",
                    "university": "",
                    "status": "Please select...",
                    "specialization": ""
                });
            }
        },
        validateStep1(n){
            const that = this;

            that.revalidateForm("Name");
            that.revalidateForm("Address");
            that.revalidateForm("Phone");

            let firstname = that.generalinfo.firstname.length;
            let lastname = that.generalinfo.lastname.length;
            let street = that.generalinfo.address.street.length;
            let city = that.generalinfo.address.city.length;
            let province = that.generalinfo.address.province.length;
            let postalcode = that.generalinfo.address.postalcode.length;
            let homephone = that.generalinfo.phone.home.length;
            let cellphone = that.generalinfo.phone.cell.length;

            if(firstname>0 && lastname>0 && street>0 && city>0 && province>0 && postalcode>0 && (homephone>0 || cellphone>0)){
                that.step1 = true;
            }else {
                that.step1 = false;
            }
            that.e1 = n;

            if(firstname == 0 || lastname == 0){
                that.validatedFields.push({field: "Name", explanation: "Both of first name and last name must be entered"});
            }else {
                that.revalidateForm("Name");
            }

            if(street == 0 || city == 0 || province == 0 || postalcode == 0){
                that.validatedFields.push({field: "Address", explanation: "All address details must be entered"});
            }else {
                that.revalidateForm("Address");
            }

            if(homephone == 0 && cellphone == 0){
                that.validatedFields.push({field: "Phone", explanation: "At least one of home or cell phone number must be entered"})
            }else {
                that.revalidateForm("Phone");
            }
        },
        validateStep2(n){
            const that= this;

            that.revalidateForm("Education History");
            
            let degree = that.education[0].degree.length;
            let university = that.education[0].university.length;
            let status = that.education[0].status;
            let specialization = that.education[0].specialization.length;
            if(degree>0 && university>0 && status != "Please select..." && specialization>0){
                that.step2 = true;
            }else {
                that.step2 = false;
            }

            that.e1 = n;

            if(degree == 0 || university == 0 || status == "Please select..." || specialization == 0){
                that.validatedFields.push({field: "Education History", explanation: "At least one education history must be entered fully"});
            }else {
                that.revalidateForm("Education History");
            }
        },
        validateStep3(n){
            const that = this;

            that.revalidateForm("Employment history");

            if(that.employment.taught == "Yes" && that.employment.courses.length>0){
                that.step3 = true;
            }else if(that.employment.taught == "No"){
                that.step3 = true;
            }else {
                that.step3 = false;
            }
            that.e1 = n;

            if(that.employment.taught == "Yes" && that.employment.courses.length == 0){
                that.validatedFields.push({field: "Employment history", explanation: "Courses taught at King's must be entered"});
            }else {
                that.revalidateForm("Employment history");
            }
        },
        validateStep4(n){
            const that = this;

            that.revalidateForm("References");
            //reference 1
            let name1 = that.references[0].name.length;
            let affiliation1 = that.references[0].academicaffiliation.length;
            let email1 = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(that.references[0].email);
            let phone1 = that.references[0].phone.length;
            //reference 2
            let name2 = that.references[1].name.length;
            let affiliation2 = that.references[1].academicaffiliation.length;
            let email2 = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(that.references[1].email);
            let phone2 = that.references[1].phone.length;
            //reference 3
            let name3 = that.references[2].name.length;
            let affiliation3 = that.references[2].academicaffiliation.length;
            let email3 = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(that.references[2].email);
            let phone3 = that.references[2].phone.length;

            if(name1>0 && name2>0 && name3>0 && affiliation1>0 && affiliation2>0 && affiliation3>0 && email1 && email2 && email3 && phone1>0 && phone2>0 && phone3>0){
                that.step4 = true;
            }else {
                that.step4 = false;
            }

            that.e1 = n;

            if(name1 == 0 || name2 == 0 || name3 == 0 || affiliation1 == 0 || affiliation2 == 0 || affiliation3 == 0 || !email1 || !email2 || !email3 || phone1 == 0 || phone2 == 0 || phone3 == 0){
                that.validatedFields.push({field: "References", explanation: "All 3 reference information must be completed fully."});
            }else {
                that.revalidateForm("References");
            }

        },
        validateStep5(n){
            const that = this;

            that.revalidateForm("Resume/CV");
            that.revalidateForm("Supplemental Document Type 1");
            that.revalidateForm("Supplemental Document Type 2");
            that.revalidateForm("Attachment File Size");
            that.revalidateForm("Application Confirmation");

            var sizeCV = 0;
            var sizeSupple1 = 0;
            var sizeSupple2 = 0;

            if(!(that.applicantCV === null || that.applicantCV === "")){
                sizeCV = document.getElementById('fileCV').files[0].size;
            }else {
                sizeCV = 0;
            }

            if(!(that.supplementdoc1 === null || that.supplementdoc1 === "")){
                sizeSupple1 = document.getElementById('suppledoc1').files[0].size;
            }else {
                sizeSupple1 = 0;
                that.supplementdoctype1 = "Please select...";
            }

            if(!(that.supplementdoc2 === null || that.supplementdoc2 === "")){
                sizeSupple2 = document.getElementById('suppledoc2').files[0].size;
            }else {
                sizeSupple2 = 0;
                that.supplementdoctype2 = "Please select...";
            }

            var totalfilesize = sizeCV + sizeSupple1 + sizeSupple2;

            if((that.applicantCV != null && that.applicantCV != "") && that.finalcheck){
                if((that.supplementdoc1 != null && that.supplementdoc1 != "" && that.supplementdoctype1 == "Please select...") || (that.supplementdoc2 != null && that.supplementdoc2 != "" && that.supplementdoctype2 == "Please select...")){
                    that.step5 = false;
                }else {
                    if(parseFloat(totalfilesize) >= parseFloat(10485760)){
                        that.step5 = false;
                    }else {
                        that.step5 = true;
                    }
                }
            }else {
                that.step5 = false;
            }

            that.e1 = n;

            if(that.applicantCV === null || that.applicantCV === ""){
                that.validatedFields.push({field: "Resume/CV", explanation: "Resume/CV is a mandatory document"});
            }else {
                that.revalidateForm("Resume/CV");
            }

            if(that.supplementdoc1 === null || that.supplementdoc1 === ""){
                that.revalidateForm("Supplemental Document Type 1");
            }else {
                if(that.supplementdoctype1 == "Please select..."){
                    that.validatedFields.push({field: "Supplemental Document Type 1", explanation: "Document type for the uploaded supplemental document must be selected"});
                }else {
                    that.revalidateForm("Supplemental Document Type 1");
                }
            }
            
            if(that.supplementdoc2 === null || that.supplementdoc2 === ""){
                that.revalidateForm("Supplemental Document Type 2");
            }else {
                if(that.supplementdoctype2 == "Please select..."){
                    that.validatedFields.push({field: "Supplemental Document Type 2", explanation: "Document type for the uploaded supplemental document must be selected"});
                }else {
                    that.revalidateForm("Supplemental Document Type 2");
                }
            }

            if(parseFloat(totalfilesize) >= parseFloat(10485760)){
                that.validatedFields.push({field: "Attachment File Size", explanation: "The maximum total size of the attached documents is 10 MB."});
            }else {
                that.revalidateForm("Attachment File Size");
            }

            if(!that.finalcheck){
                that.validatedFields.push({field: "Application Confirmation", explanation: "You must agree to application confirmation terms to proceed"});
            }else {
                that.revalidateForm("Application Confirmation");
            }
        },
        validateForm(){
            const that = this;
            that.validateStep5(5);
            that.$refs.form.validate();

            if(that.step1 && that.step2 && that.step3 && that.step4 && that.step5){

                that.dialogValidation = false;
                that.dialogConfirm = true;
                
            }else {
                that.dialogConfirm = false;
                that.dialogValidation = true;
            }
        },
        revalidateForm(entry){
            const that = this;
            for(var i=0;i<that.validatedFields.length;i++){
                if(that.validatedFields[i]["field"] == entry){
                    that.validatedFields.splice(i,1);
                }
            }
        },
        postingExpired(){
            const that = this;
            let expired = [];
            const MSPERDAY = 1000 * 60 * 60 * 24;
            let today = new Date();
            let todayutc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            
            that.posting.forEach(element => {
                let enddate = new Date(element["endDate"]);
                let dateutc = Date.UTC(enddate.getFullYear(), enddate.getMonth(), enddate.getDate());

                let daysleft = Math.floor((dateutc - todayutc) / MSPERDAY)+1;
                if(daysleft < 0){
                    expired.push("true")
                }
            });

            if(expired.length > 0){
                return true
            }else {
                return false
            }
        },
        checkCartItem(){
            const that = this;

            //End of API calling
        },
        submitApplication(){
            const that = this;

            let user = auth.get_user();
            if(user["department"] != "applicant"){
                that.setSnackbar("Application process completed. Submission will be saved for the applicants only.",  "#055C9D");
                that.dialogConfirm = false;
            }else {
                let emailpattern = new RegExp(that.generalinfo.email, "i")
                if(!emailpattern.test(user["email"])){
                    that.submissionText = "Applicant email does not match with the account profile. Browser's auto-completion feature may have caused this. Please close and re-open the form.";
                    that.submissiontype = "warning";
                    that.submissionsuccessful = true;
                    that.dialogConfirm = false;
                }else {
                    var count = 0;
                    //Session Reading
                    let uid = "";
                    if(sessionStorage.getItem('cupeapp_aaa')){
                        uid = auth.get_impersonated_user()["uid"];
                    }else {
                        uid = auth.get_user()["uid"];
                    }

                    let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getrawcart&data={"uid": "'+uid+'"}';

                    //API calling
                    fetch(api)
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (resultData) {
                            if(!resultData.result.match(/^OK/i)){
                                count = 0;
                            }else {
                                if(resultData.data[0].hasOwnProperty("cartData")){
                                    count = resultData.data[0].cartData.length;
                                }else {
                                    count = 0;
                                }

                                if(that.posting.length == count){
                                    that.submitApplicationAPI();
                                }else {
                                    that.submissionText = "There is at least one expired posting in your application. Please close the application form and re-apply using the Cart.";
                                    that.submissiontype = "warning";
                                    that.submissionsuccessful = true;
                                    that.dialogConfirm = false;
                                }
                            }
                        })
                        .catch(function(){
                            that.submissionText = "There is at least one expired posting in your application. Please close the application form and re-apply using the Cart.";
                            that.submissiontype = "warning";
                            that.submissionsuccessful = true;
                            that.dialogConfirm = false;
                        })
                }
            }
        },
        submitApplicationAPI(){
            const that = this;
            that.submissionloading = true;

            let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
            }else {
                uid = auth.get_user()["uid"];
            }
            
            let applicationData = {
                "discipline": that.posting[0]["courses"][0]['subject-resolved'],
                "postings": that.posting,
                "cupeposition": that.taughtatkings,
                "legaltowork": that.eligibletowork,
                "generalinfo": that.generalinfo,
                "education": that.education,
                "employment": that.employment,
                "references": that.references
            }

            const formData = new FormData();
            formData.append("mode", "submitApplication");
            formData.append("uid", uid);
            formData.append("fileCV", document.getElementById("fileCV").files[0]);

            if(that.supplementdoc1 != null && that.supplementdoc1 != ""){
                formData.append("filesupple1", document.getElementById("suppledoc1").files[0]);
                applicationData["suppletype1"] = that.supplementdoctype1;    
            }

            if(that.supplementdoc2 != null && that.supplementdoc2 != ""){
                formData.append("filesupple2", document.getElementById("suppledoc2").files[0]);
                applicationData["suppletype2"] = that.supplementdoctype2;
            }

            formData.append("data", JSON.stringify(applicationData));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.dialogConfirm = false;
                    that.submissiontype = "success";
                    that.submissionText = "Your application has been submitted successfully. Please close the application form to return to your cart or to browse other postings.";
                    that.dialogSubmissionsuccessful = true;
                    that.submissionsuccessful = true;
                }else {
                    that.dialogConfirm = false;
                    that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                }
                that.submissionloading = true;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>